<div class="dx-card padding-content">
    <dx-toolbar #toolbar>
        <dxi-item location="center" text="{{ title }}"></dxi-item>
        <dxi-item
            location="after"
            widget="dxButton"
            [options]="refreshButtonOptions"
            [disabled]="isDataLoading"
        ></dxi-item>
    </dx-toolbar>
    <dx-tabs
        #statusTabs
        keyExpr="key"
        [items]="orderStatuses"
        [scrollByContent]="true"
        [showNavButtons]="true"
        (onSelectionChanged)="orderStatusSelectionChanged($event)"
        [(selectedItem)]="selectedTabItem"
    ></dx-tabs>

    <dx-data-grid
        #dataGrid
        id="tiktokOrderGrid"
        [showBorders]="true"
        [dataSource]="orderSource"
        [masterDetail]="{ enabled: true, template: 'tiktokOrderDetails' }"
        [hoverStateEnabled]="true"
        [disabled]="isDataLoading"
        keyExpr="id"
    >
        <div *dxTemplate="let row of 'tiktokOrderDetails'">
            <dx-form id="form" [colCount]="4">
                <dxi-item itemType="group" caption="Order Details">
                    <div class="dx-field">
                        <div class="dx-field-label">Order ID</div>
                        <div class="dx-field-value-static">
                            {{ row.data.id }}
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label">Status</div>
                        <div class="dx-field-value-static">
                            {{ row.data.status }}
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label">Buyer Message</div>
                        <div class="dx-field-value-static">
                            {{ row.data.buyer_message }}
                        </div>
                    </div>
                </dxi-item>
                <dxi-item itemType="group" caption="Date">
                    <div class="dx-field">
                        <div class="dx-field-label">Creation Time</div>
                        <div class="dx-field-value-static">
                            {{
                                row.data.$create_time_date
                                    | date : "d MMM y HH:mm"
                            }}
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label">Update Time</div>
                        <div class="dx-field-value-static">
                            {{
                                row.data.$update_time_date
                                    | date : "d MMM y HH:mm"
                            }}
                        </div>
                    </div>
                </dxi-item>
                <dxi-item itemType="group" caption="Recipient Info">
                    <div class="dx-field">
                        <div class="dx-field-label">Name</div>
                        <div class="dx-field-value-static">
                            {{ row.data.recipient_address?.name }}
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label">Address</div>
                        <div class="dx-field-value-static">
                            {{ row.data.recipient_address?.full_address }}
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label">Phone</div>
                        <div class="dx-field-value-static">
                            {{ row.data.recipient_address?.phone_number }}
                        </div>
                    </div>
                </dxi-item>
                <dxi-item itemType="group" caption="Payment">
                    <div class="dx-field">
                        <div class="dx-field-label">Payment Method</div>
                        <div class="dx-field-value-static">
                            {{ row.data.payment_method_name }}
                        </div>
                    </div>
                    <div class="dx-field">
                        <div class="dx-field-label">Total Amount</div>
                        <div class="dx-field-value-static">
                            {{ row.data.payment?.total_amount | formatNumber : 2 }}
                        </div>
                    </div>
                </dxi-item>
            </dx-form>
            <dx-data-grid
                [showBorders]="true"
                [dataSource]="row.data.groupedOrderItems"
            >
                <dxi-column
                    dataField="itemNo"
                    caption="Item No."
                    [width]="120"
                    dataType="number"
                ></dxi-column>
                <dxi-column
                    dataField="description"
                    caption="Description"
                    [minWidth]="120"
                ></dxi-column>
                <dxi-column
                    dataField="quantity"
                    caption="Quantity"
                    [width]="120"
                    dataType="number"
                ></dxi-column>
                <dxi-column
                    dataField="unitPrice"
                    caption="Unit Price"
                    [width]="120"
                    dataType="number"
                    cellTemplate="priceTemplate"
                ></dxi-column>
                <dxi-column
                    dataField="amount"
                    caption="Amount"
                    [width]="120"
                    dataType="number"
                    cellTemplate="priceTemplate"
                ></dxi-column>
                <div *dxTemplate="let cellData of 'priceTemplate'">
                    {{ cellData.value | formatNumber : 2 }}
                </div>
            </dx-data-grid>
        </div>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-paging [pageSize]="18"> </dxo-paging>
        <dxo-pager
            [visible]="true"
            [allowedPageSizes]="18"
            displayMode="full"
            [showInfo]="true"
            [showNavigationButtons]="true"
        >
        </dxo-pager>
        <dxi-column
            dataField="$create_time_date"
            dataType="datetime"
            caption="Creation Time"
            [width]="180"
            format="d MMM y HH:mm"
            alignment="left"
        >
        </dxi-column>
        <dxi-column
            dataField="id"
            caption="Order ID"
            [width]="180"
            alignment="left"
        ></dxi-column>
        <dxi-column
            dataField="matching"
            caption="Matching"
            [width]="100"
        ></dxi-column>
        <dxi-column
            dataField="recipient_address.name"
            caption="Recipient Name"
            [minWidth]="150"
        ></dxi-column>
        <dxi-column
            dataField="payment_method_name"
            caption="Payment Method"
        ></dxi-column>
        <dxi-column
            dataField="payment.total_amount"
            caption="Total"
            [width]="120"
            dataType="number"
            cellTemplate="priceTemplate"
        ></dxi-column>
        <div *dxTemplate="let cellData of 'priceTemplate'">
            {{ cellData.value | formatNumber : 2 }}
        </div>
        <dxi-column
            dataField="items_count"
            caption="Item Count"
            [width]="110"
            dataType="number"
        ></dxi-column>
        <dxi-column
            dataField="tracking_number"
            caption="Tracking No"
            [width]="150"
        ></dxi-column>
        @if (hasRemarks) {
        <dxi-column
            dataField="buyer_message"
            caption="Buyer Message"
        ></dxi-column>
        }

        <dxo-summary>
            <dxi-total-item
                column="id"
                summaryType="count"
                valueFormat="#,##0"
                displayFormat="Total {0} order(s)"
            >
            </dxi-total-item>
            <dxi-total-item
                column="payment.total_amount"
                summaryType="sum"
                valueFormat="฿ #,##0.00"
                displayFormat="{0}"
            >
            </dxi-total-item>
            <dxi-total-item
                column="items_count"
                summaryType="sum"
                valueFormat="#,##0"
                displayFormat="{0} item(s)"
            >
            </dxi-total-item>
        </dxo-summary>
    </dx-data-grid>
</div>
